import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterRange: 'All Time',
  genderFilter: 'ALL',
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setFilterRange: (state, action) => {
      state.filterRange = action.payload;
    },
    setGenderFilter: (state, action) => {
      state.genderFilter = action.payload;
    },
  },
});

export const { setFilterRange, setGenderFilter } = adminSlice.actions;
export default adminSlice.reducer;